<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- DADOS DO PROCESSO -->
  <div class="row" style="opacity: 0.5">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <h4 v-if="processo">Processo ID - {{ processo.id }}</h4>
              <h4 v-else>Nenhum processo associado a este leilão.</h4>
            </div>

            <!-- LEILOEIRO RESPONSÁVEL -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="endereco_cidade">Leiloeiro responsável</label>

                <select
                  disabled="true"
                  class="custom-select rounded-0"
                  id="endereco_cidade"
                  v-model="formData.leiloeiro_id"
                  style="text-transform: uppercase"
                >
                  <option v-for="leiloeiro in leiloeiros" :key="leiloeiro.id" :value="leiloeiro.id">
                    {{ leiloeiro.matricula + " - " + leiloeiro.nome }}
                  </option>
                </select>
              </div>
            </div>

            <!-- NÚMERO PROCESSO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_numero">Número do processo</label>
                <input
                  class="form-control"
                  id="processo_numero"
                  placeholder="Número do processo"
                  v-model="formData.processo_numero"
                  @blur="upper('processo_classe')"
                  style="text-transform: uppercase"
                  disabled="true"
                />
              </div>
            </div>

            <!-- NÚMERO REFERÊNCIA -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_referencia">Número de referencia</label>
                <input
                  class="form-control"
                  id="processo_referencia"
                  placeholder="Número de referência"
                  v-model="formData.processo_referencia"
                  @blur="upper('processo_referencia')"
                  style="text-transform: uppercase"
                  disabled="true"
                />
              </div>
            </div>

            <!-- EXEQUENTE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_exequente">Exequente</label>
                <input
                  class="form-control"
                  id="processo_exequente"
                  placeholder="Exequente"
                  v-model="formData.processo_exequente"
                  @blur="upper('processo_exequente')"
                  style="text-transform: uppercase"
                  disabled="true"
                />
              </div>
            </div>

            <!-- EXECUTADO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_executado">Executado</label>
                <input
                  class="form-control"
                  id="processo_executado"
                  placeholder="Executado"
                  v-model="formData.processo_executado"
                  @blur="upper('processo_executado')"
                  style="text-transform: uppercase"
                  disabled="true"
                />
              </div>
            </div>

            <!-- VARA -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_vara">Vara</label>
                <input
                  class="form-control"
                  id="processo_vara"
                  placeholder="Vara"
                  v-model="formData.processo_vara"
                  @blur="upper('processo_vara')"
                  style="text-transform: uppercase"
                  disabled="true"
                />
              </div>
            </div>

            <!-- CLASSE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_classe">Classe processual</label>
                <input
                  class="form-control"
                  id="processo_classe"
                  placeholder="Classe processual"
                  v-model="formData.processo_classe"
                  @blur="upper('processo_classe')"
                  style="text-transform: uppercase"
                  disabled="true"
                />
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_estado">Estado</label>

                <select
                  class="custom-select rounded-0"
                  id="endereco_estado"
                  v-model="formData.estado_id"
                  @change="buscarCidades()"
                  style="text-transform: uppercase"
                  disabled="true"
                >
                  <option value=""></option>
                  <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                    {{ estado.sigla }}
                  </option>
                </select>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select
                  disabled="true"
                  class="custom-select rounded-0"
                  id="endereco_cidade"
                  v-model="formData.cidade_id"
                  style="text-transform: uppercase"
                >
                  <option value=""></option>
                  <option v-for="cidade in my_cidades" :key="cidade.id" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- PUBLICACOES -->
  <div class="card card-primary">
    <div class="card-header">
      <h5 class="card-title" id="accordion">
        &nbsp; Publicações oficiais &nbsp;
        <button
          data-toggle="modal"
          data-target="#cadastrar-publicacao"
          class="btn btn-primary btn-sm"
          style="margin-left: 15px"
          @click="buscarLotes(), (cadastrar_publicacao = true)"
          type="button"
        >
          Nova publicação
          <i class="fa fa-plus" style="margin-left: 5px"></i>
        </button>
      </h5>
    </div>

    <div class="card-body table-responsive p-0">
      <table class="table table-hover">
        <thead>
          <tr>
            <th style="width: 5%">Id</th>
            <th>Titulo (apagar)</th>
            <th>Processo (apagar)</th>
            <th>Leilão</th>
            <th>Lote (apagar)</th>
            <th>Link publicação</th>
            <th>Conteúdo</th>
            <th>Criação</th>
            <th>Atualização</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="publicacao in editais" :key="publicacao">
            <td>{{ publicacao.id }}</td>
            <td>{{ publicacao.nome }}</td>
            <td>
              <span v-if="publicacao.leilao">{{ publicacao.leilao.processo_id }}</span>
            </td>
            <td>
              <a :href="'/admin/leilao/' + publicacao.leilao_id">{{ publicacao.leilao_id }}</a>
            </td>
            <td>
              <a :href="'/admin/leilao/' + publicacao.leilao_id + '/lotes/editar/' + publicacao.lote_id">{{ publicacao.lote_id }}</a>
            </td>
            <td>
              <a v-if="publicacao.id && publicacao.tipo == 'publicacao'" :href="'/' + publicacao.id + '/publicacao'" target="_blank">
                Link publicação
              </a>
            </td>
            <td>
              <button @click="getEdital(publicacao)" type="button" class="btn btn-primary btn-sm">
                Conteúdo
                <i style="margin-left: 3px" class="fa fa-search"></i>
              </button>
            </td>
            <td>{{ formatDate(publicacao.created_at) }}</td>
            <td>{{ formatDate(publicacao.updated_at) }}</td>
            <td>
              <a
                id="navbarDropdown"
                class="nav-link"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                v-pre
              >
                <i class="fa-solid fa-bars" style="color: gray"></i>
              </a>

              <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                <div class="dropdown-divider"></div>
                <a href="#" @click="deletarPublicacao(publicacao)" class="dropdown-item">
                  <i class="fa-solid fa-trash"></i>
                  &nbsp;&nbsp; Deletar
                </a>
                <div class="dropdown-divider"></div>
                <a href="#" @click="enviarEmail(publicacao)" class="dropdown-item">
                  <i class="fa-solid fa-pen"></i>
                  &nbsp;&nbsp; Enviar e-mail
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- MODAL CADASTRAR PUBLICAÇÃO -->
  <div class="modal fade" id="cadastrar-publicacao" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="endereco_cidade">Lote</label>

                  <select class="custom-select rounded-0" v-model="formData.lote_id" style="text-transform: uppercase">
                    <option value=""></option>
                    <option v-for="lote in lotes" :key="lote.id" :value="lote.id">
                      {{ lote.id }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- TÍTULO -->
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="endereco_cidade">Título</label>

                  <input
                    class="form-control"
                    id="processo_numero"
                    v-model="formData.titulo"
                    @blur="upper('titulo')"
                    style="text-transform: uppercase"
                  />

                  <span v-if="formData.cadastrar_publicacao" style="color: red" v-for="error in v$.titulo.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <!-- CONTEÚDO -->
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="endereco_cidade">Conteudo</label>

                  <Editor
                    class="editor_prime"
                    style="background-color: white"
                    editorStyle="height: 200px;"
                    v-model="formData.conteudo"
                    id="conteudo_notificacao"
                  />

                  <span v-if="formData.cadastrar_publicacao" style="color: red" v-for="error in v$.conteudo.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <button @click="store" class="btn btn-primary btn-sm">Salvar</button>
                <button
                  style="margin-left: 5px"
                  id="open_close_cadastrar_publicacao"
                  data-toggle="modal"
                  data-target="#cadastrar-publicacao"
                  class="btn btn-danger btn-sm"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";
import Editor from "primevue/editor";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["leilao", "estados", "cidades", "leiloeiros", "publicacao"],

  components: { Loading, Editor },

  data() {
    return {
      nome: "",
      isLoading: false,
      my_cidades: [],
      processo: "",
      editar: false,
      editais: "",
      lotes: [],
    };
  },

  setup() {
    const formData = reactive({
      leiloeiro_id: "",
      processo_numero: "",
      processo_referencia: "",
      processo_executado: "",
      processo_exequente: "",
      processo_comitente: "",
      processo_vara: "",
      processo_classe: "",
      processo_data_leiloes: "",
      processo_onus: "",
      processo_advogados: "",
      processo_local_leilao: "",
      processo_juiz_complemento: "",
      processo_juiz: "",
      processo_depositario: "",
      processo_valor_avaliacao: "",
      processo_valor_originario: "",
      processo_valor_debito: "",

      cidade_id: "",
      cidade_id: "",

      lote_id: "",
      leilao_id: "",
      titulo: "EDITAL",
      conteudo: "",
      cadastrar_publicacao: false,
    });

    const rules = computed(() => {
      let local_rules = {};

      local_rules.titulo = { required };
      local_rules.conteudo = { required };
      local_rules.leilao_id = { required };

      return local_rules;
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.my_cidades = this.cidades;

    this.processo = this.leilao.processo;

    console.log("Processo");
    console.log(this.processo);

    if (this.processo) {
      this.formData.leiloeiro_id = this.processo.leiloeiro_id;
      this.formData.processo_numero = this.processo.processo_numero;
      this.formData.processo_referencia = this.processo.processo_referencia;
      this.formData.processo_executado = this.processo.processo_executado;
      this.formData.processo_exequente = this.processo.processo_exequente;
      this.formData.processo_comitente = this.processo.processo_comitente;
      this.formData.processo_vara = this.processo.processo_vara;
      this.formData.processo_classe = this.processo.processo_classe;
      this.formData.processo_data_leiloes = this.processo.processo_data_leiloes;
      this.formData.processo_onus = this.processo.processo_onus;
      this.formData.processo_advogados = this.processo.processo_advogados;
      this.formData.processo_local_leilao = this.processo.processo_local_leilao;
      this.formData.processo_juiz_complemento = this.processo.processo_juiz_complemento;
      this.formData.processo_juiz = this.processo.processo_juiz;
      this.formData.processo_depositario = this.processo.processo_depositario;
      this.formData.processo_valor_avaliacao = this.processo.processo_valor_avaliacao;
      this.formData.processo_valor_originario = this.processo.processo_valor_originario;
      this.formData.processo_valor_debito = this.processo.processo_valor_debito;
      this.formData.cidade_id = this.processo.cidade_id;
      this.formData.estado_id = this.processo.estado_id;
    }

    /*
    if (this.publicacao && this.publicacao.id) {
      this.editar = true;
      this.formData.titulo = this.publicacao.titulo;
      this.formData.conteudo = this.publicacao.conteudo;
    }
      */

    console.log("Publi");
    console.log(this.publicacao);

    this.buscarEditais();
  },

  methods: {
    enviarEmail(publicacao) {
      let html = "Deseja enviar e-mail sobre esta publicação? ";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero enviar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              publicacao_id: publicacao.publicacao.id,
            };

            console.log(publicacao);

            this.isLoading = false;

            axios
              .post(`/admin/publicacao/send_email`, data)
              .then((response) => {
                this.showSuccessMessageWithButton("Sucesso", "E-mail enviado com sucesso!");
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    deletarPublicacao(publicacao) {
      let html = "Deseja deletar esta publicação? ";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              publicacao_id: publicacao.publicacao.id,
            };

            console.log(publicacao);

            axios
              .post(`/admin/publicacao/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButtonAndReload("Sucesso", "Publicação deletada com sucesso!");
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    buscarLotes() {
      let data = {
        processo_id: this.processo.id,
        leilao_id: this.leilao.id,
        inicio: 0,
        tamanho: 10000,
      };

      axios
        .post(`/admin/lotes/search`, data)
        .then((response) => {
          console.log("Lotes");
          console.log(response.data);

          this.lotes = response.data.lotes;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarEditais() {
      let data = {
        leilao_id: this.leilao.id,
        inicio: 0,
        tamanho: 10000,
      };

      axios
        .post(`/editais/find_all_by_leilao`, data)
        .then((response) => {
          this.editais = response.data.editais;

          console.log("Editais");
          console.log(this.editais);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    getEdital(edital) {
      console.log(edital);

      if (edital.tipo == "publicacao") {
        window.open("/" + edital.id + "/publicacao", "_blank").focus();
      } else if (edital.tipo == "anexo") {
        let url = "";

        if (edital.path.includes("rochaleiloes2")) {
          url = process.env.MIX_VUE_APP_S3_BASE2_URL + edital.path + "/" + edital.file;
        } else if (edital.path.includes("rochaleiloes")) {
          url = process.env.MIX_VUE_APP_S3_BASE_URL + edital.path + "/" + edital.file;
        } else {
          url = process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + edital.path + "/" + edital.file;
        }

        window.open(url, "_blank").focus();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },

    upper(field_name) {
      console.log(field_name);
      this.formData[field_name] = this.formData[field_name].toUpperCase();
      console.log(this.formData[field_name]);
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        if (this.editar) {
          this.update();
        } else {
          this.store();
        }
      }
    },

    store() {
      this.isLoading = true;

      let data = {
        titulo: this.formData.titulo,
        conteudo: this.formData.conteudo,
        leilao_id: this.leilao.id,
        lote_id: this.formData.lote_id,
      };

      if (this.processo) {
        data.processo_id = this.processo.id;
      }

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/publicacao/store`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Publicação cadastrada", "/admin/publicacao/" + this.leilao.id);
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    update() {
      this.isLoading = true;

      let data = {
        publicacao_id: this.publicacao.id,
        titulo: this.formData.titulo,
        conteudo: this.formData.conteudo,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/publicacao/update`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Publicação atualizada", "/admin/publicacao/" + this.leilao.id);
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.formData.estado_id,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.my_cidades = response.data.cidades;

          this.formData.cidade_id = null;

          console.log(response.data);

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1040px;
  margin-left: -250px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 900px;
    margin-left: -00px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 900px;
    margin-left: -180px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
